import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    zIndex: "closed",
  },
  reducers: {
    setHeaderZIndex: (state, action) => {
      state.zIndex = action.payload;
    },
  },
});

export const { setHeaderZIndex } = headerSlice.actions;

export const selectHeaderZIndex = (state) => state.header.zIndex;

export default headerSlice.reducer;
